(function (){
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('ShopperProfiles', ShopperProfiles);

  function ShopperProfiles($q, $translate, HighChartsService){

    var barChartOptions = {
      plotOptions: {
        series: {
          clip: false,
          stacking: 'normal'
        }
      }
    };

    var horizontalBarChartOptions = _.merge({}, barChartOptions, {
      chart: {
        type: 'bar',
        height: 350,
        spacing: [0, 20, 0, 0]
      },
      xAxis: [
        {
          labels: {
            align: 'left',
            reserveSpace: true
          }
        },
        {
          labels: {
            align: 'left',
            reserveSpace: true
          }
        }
      ]
    });

    var verticalBarChartOptions = _.merge({}, barChartOptions, {
      chart: {
        type: 'column',
        height: 250,
        spacing: [20, 5, 40, 5]
      },
      xAxis: [
        {
          labels: {
            autoRotation: false,
            reserveSpace: false,
            formatter: function() {
              return _(this.value).words().join(' \n');
            },
            style: {
              textOverflow: 'none'
            }
          }
        },
        {
          labels: {
            autoRotation: false
          }
        }
      ]
    });

    var chartOptions = {
      bar: horizontalBarChartOptions,
      column: verticalBarChartOptions
    };

    return {
      getChartOptions: getChartOptions,
      getDataOptions: getDataOptions,
      getMeasurements: getMeasurements,
      shopperProfilesData: shopperProfilesData,
      bodyShapeData: bodyShapeData,
      genderDisplay: genderDisplay
    };

    function pctValue(value) {
      return value * 100;
    }

    function shopperProfilesData(data, gender, unit) {
      var genderData = _(data.profileValues).filter( { gender: gender } );
      var rangeInUnits = _(genderData).find( { unit: unit } ) || _(genderData).first();
      return rangeInUnits && _.map(rangeInUnits.rangeMetricValues, function (v) {
        return {range: v.range, value: pctValue(v.value) };
      });
    }

    function bodyShapeData(data, gender, bodyShape) {
      var bodyShapeData = _(data.profileValues).find( { gender: gender, bodyShape: bodyShape } );
      return bodyShapeData && _(bodyShapeData.rangeMetricValues)
          .filter(function (v) { return v.range !== 'N/A'; })
          .map(function (v) {
            return {range: v.range, value: pctValue(v.value) };
          })
          .value();
    }

    function genderDisplay(gender) {
      var genderDisplayName = gender.range === 'Unspecified' ? 'Did Not Specify' : gender.range;
      return genderDisplayName + ' - ' + _.round(pctValue(gender.value)) + '%\n of consumers'
    }

    function getMeasurements(data, gender, attribute) {
      return _(data.profileValues)
              .filter( { gender: gender } )
              .map(attribute)
              .filter(function (range) {
                return !_.isNil(range);
              })
              .sortBy().reverse().value();
    }

    function getChartOptions(section, selectedUnit) {
      var baseOptions = HighChartsService.getBaseOptions();
      return _.merge({}, baseOptions, chartOptions[section.chart.chartType], {
        chartTitle: $translate.instant(section.chart.label),
        name: section.name,
        selectedUnit: selectedUnit,
        showChart: function () {
          return !this.series || _.some(this.series[1].data, function (measurement) {
            return measurement.y > 0;
          });
        }
      });
    }

    function getDataOptions(apiData, gender, measurementName, formatDataFunc) {
      var measurementNames = getMeasurements(apiData, gender, 'unit');
      var selectedMeasurementName = measurementName || measurementNames[0];
      var data = formatDataFunc(apiData, gender, selectedMeasurementName);

      // Rounding the max value to the next multiple of 10, with a min of 10
      var maxPct = _.maxBy(data, 'value');
      var maxY = Math.max(10, Math.ceil(maxPct && maxPct.value / 10) * 10);


      return {
        units: measurementNames,
        selectedUnit: selectedMeasurementName,
        yAxis: {
          min: 0,
          max: maxY,
          visible: false,
          endOnTick: false,
          title: false
        },
        xAxis: [
          {
            categories: _.map(data, 'range')
          },
          {
            opposite: true,
            linkedTo: 0,
            categories: _.map(data, function (val) {
              return _.round(val.value) + "%";
            })
          }
        ],
        series: [
          {
            data: _.map(data, function (val) {
              return {
                y: maxY - val.value,
                stack: 0,
                className: 'bg-color dash-stroke'
              }
            })
          },
          {
            data: _.map(data, function (val) {
              var colorClass = val.range === 'Unspecified' ? 'bot-color' : 'tf-color';
              return {
                y: val.value,
                stack: 0,
                className: colorClass + ' bar-stroke'
              }
            })
          }
        ]
      }
    }


  }

})();